import merge from 'lodash/merge';
import kz from './kz.json';
import ru from './ru.json';
import ruRU from './ru-RU.json';
import ruKZ from './ru-KZ.json';
import kzKZ from './kz-KZ.json';
import ruAE from './ru-AE.json';
import enAE from './en-AE.json';
import ar from './ar.json';
import en from './en.json';
import RUOptions from './RU.options.json';
import KZOptions from './KZ.options.json';
import AEOptions from './AE.options.json';
import arAEOptions from './ar-AE.options.json'; //TODO: удалить

export const locales = {
  'ru-RU': merge({}, ru, ruRU, RUOptions),

  'ru-KZ': merge({}, ru, ruKZ, KZOptions),
  'kz-KZ': merge({}, ru, ruKZ, kz, kzKZ, KZOptions), // если не будет перевода на казахском, то будет использоваться перевод на русском

  'ru-AE': merge({}, ru, ruAE, AEOptions),
  'ar-AE': merge({}, ru, en, ar, AEOptions, arAEOptions),
  'en-AE': merge({}, ru, en, enAE, AEOptions),
};
